import { createFrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api';
import DescriptionIcon from '@material-ui/icons/Description';
import HomeIcon from '@material-ui/icons/Home';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import AddIcon from '@material-ui/icons/Add';

const homePage = PageBlueprint.make({
  name: 'home',
  params: {
    path: '/',
    title: 'Home',
    icon: <HomeIcon />,
    noHeader: true,
    loader: () => import('./pages/HomePage').then(m => <m.HomePage />),
  },
});

const libraryPage = PageBlueprint.make({
  name: 'library',
  params: {
    path: '/agents',
    title: 'Agent Library',
    icon: <LibraryBooksIcon />,
    noHeader: true,
    loader: () => import('./pages/LibraryRoute').then(m => <m.LibraryRoute />),
  },
});

const createPage = PageBlueprint.make({
  name: 'create',
  params: {
    path: '/create/agent',
    title: 'Create Agent',
    icon: <AddIcon />,
    noHeader: true,
    loader: () => import('./pages/CreateRoute').then(m => <m.CreateRoute />),
  },
});

const executionsPage = PageBlueprint.make({
  name: 'executions',
  params: {
    path: '/executions',
    title: 'Executions',
    icon: <PlayArrowIcon />,
    noHeader: true,
    loader: () => import('./pages/ExecutionsPage').then(m => <m.ExecutionsPage />),
  },
});

const docsPage = PageBlueprint.make({
  name: 'docs',
  params: {
    path: '/documentation',
    title: 'Documentation',
    icon: <DescriptionIcon />,
    noHeader: true,
    loader: () => import('./pages/DocumentationPage').then(m => <m.DocumentationPage />),
  },
});

const detailPage = PageBlueprint.make({
  name: 'detail',
  params: {
    path: '/agents/:agentId',
    title: 'Agent',
    noHeader: true,
    loader: () => import('./pages/DetailRoute').then(m => <m.DetailRoute />),
  },
});

const placeholders = [
  ['journeys', '/journey-packs', 'Journey Packs'],
  ['solutions', '/solution-packs', 'Solution Packs'],
  ['connectors', '/connector-packs', 'Connector Packs'],
  ['evaluations', '/evaluations', 'Evaluations'],
  ['governance', '/governance', 'Governance'],
].map(([name, path, title]) => PageBlueprint.make({
  name,
  params: {
    path,
    noHeader: true,
    loader: () => Promise.resolve(
      <main className="studio-page">
        <h1>{title}</h1>
        <p>Not in this increment. Agent Studio is the first building block of the Solution Pack Console.</p>
      </main>,
    ),
  },
}));

export const agentLibraryPlugin = createFrontendPlugin({
  pluginId: 'inshift-agent-library',
  extensions: [homePage, libraryPage, detailPage, createPage, executionsPage, docsPage, ...placeholders],
});
